import { getProductPerformanceReport } from "@/api/report-api";
import { buildCacheKey, useCollectionData } from "@/hooks/use-api";
import { ProductPerformanceResponse } from "@/types/report-type";

export function useProductPerformance(
    fromDate: string,
    toDate: string,
    limit?: number
) {
    const cacheKey = buildCacheKey("product-performance", { fromDate, toDate, limit });

    return useCollectionData<ProductPerformanceResponse>(
        cacheKey,
        () => getProductPerformanceReport(fromDate, toDate, limit),
        {
            refreshInterval: 0,
            revalidateOnFocus: false,
        }
    );
}
